export const isPdfExportMode = () => window.EVERYSTAT_PDF_EXPORT_MODE === true
